import React, { useEffect, useMemo, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Grid,
    Autocomplete,
    Alert,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Snackbar,
    Pagination,
    MenuItem,
    InputAdornment,
    IconButton,
    // Snackbar,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
    showLoader,
    hideLoader,
    showAlert,
} from "../../redux/Common/commonActions";
import { postRequest, getRequest } from "../../globalhelper/helper";
import _ from "lodash";
import { GetApp } from "@material-ui/icons";
import { CSVLink } from "react-csv";
const ACTIVITY_COLUMNS = [
    { key: "ActivityId", label: "Activity ID" },
    { key: "StrategyName", label: "Strategy Name" },
    { key: "LOB", label: "LOB" },
    { key: "Function", label: "Function" },
    // { key: "SubFunction", label: "Sub Function" },
    { key: "ActivityCategory", label: "Activity Category" },
    { key: "ActivityType", label: "Activity Type" },
    { key: "ActivityName", label: "Activity Name" },
    { key: "ActivityCode", label: "Activity Code" },
    { key: "Dependency", label: "Dependency" },
    { key: "ForPrdFrom", label: "For Period From" },
    { key: "ActivityStatus", label: "Activity Status" },
];

// Default rows for Assign AP popup
const ASSIGN_AP_DEFAULT_ROWS = [
    {
        StrategyName: "BillApproval",
        Function: "Admin",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Admin Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Customer Support & Delivery",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Customer Support & Delivery Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Finance",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Finance Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "HR",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "HR Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Marketing",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Marketing Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Product",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Product Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Sales",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Sales Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "BillApproval",
        Function: "Technology",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Technology Head Approval",
        ActivityCode: "BEH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Admin",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Admin Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Customer Support & Delivery",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Customer Support & Delivery Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Finance",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Finance Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "HR",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "HR Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Marketing",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Marketing Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Product",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Product Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Sales",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Sales Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
    {
        StrategyName: "POApproval",
        Function: "Technology",
        SubFunction: "",
        ActivityCategory: "User",
        ActivityType: "Approval",
        ActivityName: "Technology Head Approval",
        ActivityCode: "POH001",
        Dependency: "",
        ForPrdFrom: moment().startOf("month").format("YYYY-MM-DD"),
        ForPrdTo: moment().endOf("month").format("YYYY-MM-DD"),
        ActivityStatus: "Not Released",
    },
];

export default function ActivityPlanReport() {
    const dispatch = useDispatch();

    const [info, setInfo] = useState({
        orgid: "",
        // ForPrdFrom: null,
        // ForPrdTo: null,
        ActivityStatus: "",
    });
    const [Companies, setCompanies] = useState([]);
    const [CSV_ARRAY, setCSV_ARRAY] = useState([]);
    const [assignAPRows, setAssignAPRows] = useState([]);
    const [copiedRows, setCopiedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [checkedMainRows, setCheckedMainRows] = useState([]);
    const [LOB, setLOB] = useState([]);
    const [filters, setFilters] = useState({
        Function: "",
        ActivityCategory: "",
        ActivityType: "",
        ActivityName: "",
        LOB: "",
        StrategyName: "",
        ActivityCode: "",
        ActivityId: "",
    });
    const [openAssignAP, setOpenAssignAP] = useState(false);
    const [deletedAssignAPRow, setDeletedAssignAPRow] = useState(null);
    const [deletedAssignAPRowIndex, setDeletedAssignAPRowIndex] = useState(null);
    const [alert, setAlert] = useState(null);
    const [selectedLOB, setSelectedLOB] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [editingMainRow, setEditingMainRow] = useState(null);
    const [editingMainRowIndex, setEditingMainRowIndex] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", isUndo: false });
    const [clipboardRow, setClipboardRow] = useState(null);
    const [deleteConfirmDialog, setDeleteConfirmDialog] = useState({ open: false, index: null });
    const [deleteUndoState, setDeleteUndoState] = useState({ row: null, index: null });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await getRequest(`api/edureka/getCompanyAssignedToUser`);
                if (res?.type === "success") {
                    const data = _.sortBy(res.res.data, "orgname");
                    setCompanies(data);
                    if (data.length === 1) {
                        setInfo((prev) => ({ ...prev, orgid: data[0].orgid }));
                    }
                }
            } catch (err) {
                console.error("Error:", err);
            }
        })();
    }, []);

    useEffect(() => {
        if (info.orgid) {
            (async () => {
                try {
                    const { res } = await getRequest(
                        `api/vr2/getLOB?orgid=${info.orgid}`
                    );
                    if (res?.status === "success") {
                        const parsedData = JSON.parse(res.data);
                        setLOB(parsedData.map((item) => Object.values(item)).flat());
                    }
                } catch (err) {
                    console.error("Error:", err);
                }
            })();
        }
    }, [info.orgid]);

    // const handleCloseSnackbar = () => setSnackbar({ open: false, message: "", action: null });
    const handleChanges = (name, val) => {
        setInfo((prev) => ({
            ...prev,
            [name]: val,
        }));
    };

    const getReport = async (e) => {
        if (e) e.preventDefault();
        dispatch(showLoader());
        setIsLoading(true);
        try {
            const res = await postRequest(`api/edureka/activityplan`, info);
            if (res?.res?.status === "success") {
                const DATA = res?.res?.data?.rows || res?.res?.data || [];
                setCSV_ARRAY(DATA);
                if (res?.res?.data?.lobs) {
                    setLOB(res.res.data.lobs.map(l => l.lob));
                }
                setShowTable(true);
                setCopiedRows([]);
                setCheckedMainRows([]);
                setFilters({
                    Function: "",
                    ActivityCategory: "",
                    ActivityType: "",
                    ActivityName: "",
                    LOB: "",
                    StrategyName: "",
                    ActivityCode: "",
                    ActivityId: "",
                });
            } else {
                setCSV_ARRAY([]);
                setShowTable(true);
            }
        } catch (err) {
            console.error(err);
            setCSV_ARRAY([]);
            setShowTable(true);
        } finally {
            dispatch(hideLoader());
            setIsLoading(false);
        }
    };

    const handleOpenAssignAP = () => {
        let maxNum = 0;
        let bestPrefix = "";
        let padLength = 0;

        if (CSV_ARRAY && CSV_ARRAY.length > 0) {
            CSV_ARRAY.forEach((row) => {
                if (row.ActivityId) {
                    const idStr = String(row.ActivityId).trim();
                    const match = idStr.match(/^(\D*)(\d+)$/);
                    if (match) {
                        const num = parseInt(match[2], 10);
                        if (num > maxNum) {
                            maxNum = num;
                            bestPrefix = match[1];
                            padLength = match[2].length;
                        }
                    }
                }
            });
        }

        const rowsWithId = ASSIGN_AP_DEFAULT_ROWS.map((row, index) => {
            let nextActivityId = "1";
            if (maxNum > 0) {
                const nextNum = maxNum + 1 + index;
                const paddedNum = String(nextNum).padStart(padLength, '0');
                nextActivityId = bestPrefix + paddedNum;
            } else {
                nextActivityId = String((CSV_ARRAY?.length || 0) + 1 + index);
            }
            return { ...row, ActivityId: nextActivityId };
        });

        setAssignAPRows(rowsWithId);
        setOpenAssignAP(true);
    };

    const handleSaveAssignAP = async () => {
        setIsLoading(true);
        dispatch(showLoader());
        if (!selectedLOB) {
            dispatch(showAlert("Please select a LOB before saving"));
            return;
        }

        try {
            const payload = {
                orgid: info.orgid,
                orgname: Companies.find((c) => c.orgid === info.orgid)?.orgname,
                data: assignAPRows.map(c => { c.lob = selectedLOB; return c; }),
            };

            console.log("Sending payload:", payload);

            const res = await postRequest("api/edureka/saveAssignAP", payload);

            if (res?.data === "success") {
                // ✅ Toast notification (top-right)
                dispatch(
                    showAlert({
                        message: "File saved successfully",
                        action: null, // No undo for save
                    })
                );

                handleCloseAssignAP();
            }
        } catch (err) {
            console.error(err);
            dispatch(showAlert("Error while saving Assign AP"));
        } finally {
            setIsLoading(false);
            dispatch(hideLoader());
        }
    };

    const handleCloseAssignAP = () => setOpenAssignAP(false);

    const handleCopyChange = (idx) => {
        setCheckedMainRows((prev) => {
            const alreadyChecked = prev.includes(idx);
            const newChecked = alreadyChecked ? prev.filter((i) => i !== idx) : [...prev, idx];
            // If exactly one row is selected, open the edit panel for it
            if (newChecked.length === 1) {
                const selectedIdx = newChecked[0];
                setEditingMainRow({ ...CSV_ARRAY[selectedIdx] });
                setEditingMainRowIndex(selectedIdx);
            } else {
                setEditingMainRow(null);
                setEditingMainRowIndex(null);
            }
            return newChecked;
        });
    };

    const handleSaveEditMainRow = async () => {
        if (editingMainRowIndex === null) return;

        if (!info.orgid) {
            dispatch(showAlert("Please select a company before saving."));
            return;
        }

        setIsLoading(true);
        dispatch(showLoader());

        try {
            const payload = {
                orgid: info.orgid,
                data: [editingMainRow],
                oldData: editingMainRowIndex === -1 ? [] : [CSV_ARRAY[editingMainRowIndex]],
            };

            const res = await postRequest("api/edureka/saveAssignAP", payload);

            if (res?.data === "success" || res?.type === "success" || res?.status === 200 || res?.res?.message === "success") {
                let updated = [...CSV_ARRAY];

                // Retrieve newly generated ActivityId if it was a new row
                let newId = null;
                if (res?.res?.data?.insertedIds && res.res.data.insertedIds.length > 0) {
                    newId = res.res.data.insertedIds[0];
                } else if (res?.res?.insertedIds && res.res.insertedIds.length > 0) {
                    newId = res.res.insertedIds[0];
                } else if (res?.data?.insertedIds && res.data.insertedIds.length > 0) {
                    newId = res.data.insertedIds[0];
                } else if (res?.insertedIds && res.insertedIds.length > 0) {
                    newId = res.insertedIds[0];
                }

                const savedRow = { ...editingMainRow };
                if (newId !== null && !savedRow.ActivityId) {
                    savedRow.ActivityId = newId;
                }

                if (editingMainRowIndex === -1) {
                    updated = [savedRow, ...CSV_ARRAY];
                } else {
                    updated[editingMainRowIndex] = savedRow;
                }
                setCSV_ARRAY(updated);
                setEditingMainRow(null);
                setEditingMainRowIndex(null);
                setCheckedMainRows([]);
                setSnackbar({ open: true, message: "Row saved to database successfully!", isUndo: false });
            } else {
                dispatch(showAlert("Failed to save row."));
            }
        } catch (err) {
            console.error(err);
            dispatch(showAlert("Error while saving row to database."));
        } finally {
            setIsLoading(false);
            dispatch(hideLoader());
        }
    };

    const handleSnackbarClose = async (event, reason) => {
        if (reason === 'clickaway') return;

        if (reason === 'timeout' && snackbar.isUndo && deleteUndoState.row) {
            const rowToDelete = deleteUndoState.row;
            try {
                const payload = {
                    orgid: info.orgid,
                    data: [{ ...rowToDelete, isdeleted: true, isDeleted: true }],
                };
                const res = await postRequest("api/edureka/saveAssignAP", payload);
                if (res?.data !== "success" && res?.type !== "success" && res?.status !== 200 && res?.res?.message !== "success" && res?.res?.status !== "success") {
                    dispatch(showAlert("Failed to permanently delete row from database."));
                }
            } catch (error) {
                console.error(error);
                dispatch(showAlert("Error permanently deleting row from database."));
            }
        }

        setSnackbar({ open: false, message: "", isUndo: false });
        if (reason === 'timeout') {
            setDeleteUndoState({ row: null, index: null });
        }
    };

    const confirmDeleteRow = () => {
        const idx = deleteConfirmDialog.index;
        if (idx !== null) {
            const rowToDelete = CSV_ARRAY[idx];
            const updated = CSV_ARRAY.filter((_, i) => i !== idx);
            setCSV_ARRAY(updated);

            if (editingMainRowIndex === idx) {
                setEditingMainRow(null);
                setEditingMainRowIndex(null);
            }

            setDeleteUndoState({
                row: rowToDelete,
                index: idx
            });
            setSnackbar({ open: true, message: "1 row is deleted", isUndo: true });
        }
        setDeleteConfirmDialog({ open: false, index: null });
    };

    const handleUndo = () => {
        if (deleteUndoState.row) {
            const updated = [...CSV_ARRAY];
            updated.splice(deleteUndoState.index, 0, deleteUndoState.row);
            setCSV_ARRAY(updated);
            setSnackbar({ open: false, message: "", isUndo: false });
            setDeleteUndoState({ row: null, index: null });
        }
    };

    const handleAddMainRow = () => {
        const emptyRow = {};
        ACTIVITY_COLUMNS.forEach((col) => { emptyRow[col.key] = ""; });

        // Auto-generate ActivityId by finding the maximum numeric value across ALL records
        let nextActivityId = "1";
        if (CSV_ARRAY && CSV_ARRAY.length > 0) {
            let maxNum = 0;
            let bestPrefix = "";
            let padLength = 0;

            CSV_ARRAY.forEach((row) => {
                if (row.ActivityId) {
                    const idStr = String(row.ActivityId).trim();
                    const match = idStr.match(/^(\D*)(\d+)$/);
                    if (match) {
                        const num = parseInt(match[2], 10);
                        if (num > maxNum) {
                            maxNum = num;
                            bestPrefix = match[1];
                            padLength = match[2].length;
                        }
                    }
                }
            });

            if (maxNum > 0) {
                const nextNum = maxNum + 1;
                const paddedNum = String(nextNum).padStart(padLength, '0');
                nextActivityId = bestPrefix + paddedNum;
            } else {
                nextActivityId = String(CSV_ARRAY.length + 1);
            }
        }
        emptyRow.ActivityId = nextActivityId;

        // DO NOT add to CSV_ARRAY yet, just show edit panel
        setEditingMainRow({ ...emptyRow });
        setEditingMainRowIndex(-1);
        setCheckedMainRows([]);
        setShowTable(true);
        setSnackbar({ open: true, message: "New row panel opened. Fill in details and click Save.", isUndo: false });
    };

    const handleSelectAllMain = () => {
        const allIndexes = filteredRows.map((_, index) => index);
        const alreadyAllSelected = checkedMainRows.length === filteredRows.length;
        setCheckedMainRows(alreadyAllSelected ? [] : allIndexes);
    };

    const handleAddAssignAPRow = (idx) => {
        const assignAPColumns = ACTIVITY_COLUMNS.filter(
            (col) => !["LOB", "SubFunction", "Dependency"].includes(col.key)
        );

        const emptyRow = {
            LOB: selectedLOB || "",
            lob: selectedLOB || "",
        };
        assignAPColumns.forEach((col) => {
            emptyRow[col.key] = "";
        });

        let maxNum = 0;
        let bestPrefix = "";
        let padLength = 0;
        const allRows = [...(CSV_ARRAY || []), ...(assignAPRows || [])];

        if (allRows.length > 0) {
            allRows.forEach((row) => {
                if (row.ActivityId) {
                    const idStr = String(row.ActivityId).trim();
                    const match = idStr.match(/^(\D*)(\d+)$/);
                    if (match) {
                        const num = parseInt(match[2], 10);
                        if (num > maxNum) {
                            maxNum = num;
                            bestPrefix = match[1];
                            padLength = match[2].length;
                        }
                    }
                }
            });
        }

        let nextActivityId = "1";
        if (maxNum > 0) {
            const nextNum = maxNum + 1;
            const paddedNum = String(nextNum).padStart(padLength, '0');
            nextActivityId = bestPrefix + paddedNum;
        } else {
            nextActivityId = String(allRows.length + 1);
        }
        emptyRow.ActivityId = nextActivityId;

        const updatedRows = [
            ...assignAPRows.slice(0, idx + 1),
            emptyRow,
            ...assignAPRows.slice(idx + 1),
        ];

        setAssignAPRows(updatedRows);
    };

    const handleDeleteAssignAPRow = (idx) => {
        try {
            const rowToDelete = assignAPRows[idx];
            if (!rowToDelete) return;

            const updatedRows = assignAPRows.filter((_, i) => i !== idx);
            setAssignAPRows(updatedRows);

            setDeletedAssignAPRow(rowToDelete);
            setDeletedAssignAPRowIndex(idx);

            setAlert({
                message: "Selected row deleted successfully",
            });
        } catch (err) {
            console.error("Error deleting row:", err);
        }
    };

    const handleUndoDelete = () => {
        if (deletedAssignAPRow && deletedAssignAPRowIndex !== null) {
            const restoredRows = [
                ...assignAPRows.slice(0, deletedAssignAPRowIndex),
                deletedAssignAPRow,
                ...assignAPRows.slice(deletedAssignAPRowIndex),
            ];

            setAssignAPRows(restoredRows);

            setDeletedAssignAPRow(null);
            setDeletedAssignAPRowIndex(null);
            setAlert(null);
        }
    };

    const handleFieldEdit = (idx, key, value, type = "main") => {
        if (type === "main") {
            const updated = [...CSV_ARRAY];
            updated[idx] = { ...updated[idx], [key]: value };
            setCSV_ARRAY(updated);
        } else {
            const updated = [...assignAPRows];
            updated[idx] = { ...updated[idx], [key]: value };
            setAssignAPRows(updated);
        }
    };

    const handleFilterChange = (key, value) => {
        setPage(0);
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const getFilteredRows = () => {
        return CSV_ARRAY.map((row, originalIndex) => ({
            row,
            originalIndex,
        })).filter(({ row }) =>
            Object.keys(filters).every((key) => {
                const rowVal = (row[key] || "").toString();
                const f = filters[key];
                return !f || f === "" || rowVal === f;
            })
        );
    };

    const safeOptions = (key, rows = CSV_ARRAY) => {
        return [
            ...new Set(
                (rows || [])
                    .map((r) => (r && r[key] ? r[key] : ""))
                    .filter((v) => v !== "")
            ),
        ];
    };

    const filteredRows = getFilteredRows();

    const assignAPColumns = useMemo(
        () =>
            ACTIVITY_COLUMNS.filter(
                (col) => !["LOB", "SubFunction", "Dependency"].includes(col.key)
            ),
        []
    );

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <div
                style={{ padding: 24, backgroundColor: "#f5f6fa", minHeight: "100vh" }}
            >
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6">
                            Please select filters to view the Activity Report
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={{ backgroundColor: "#fafafa", borderRadius: 2 }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={2.5}>
                                <Autocomplete
                                    options={Companies.map((c) => c.orgname)}
                                    value={
                                        Companies.find((c) => c.orgid === info.orgid)?.orgname || ""
                                    }
                                    onChange={(e, v) => {
                                        const selected = Companies.find((c) => c.orgname === v);
                                        handleChanges("orgid", selected ? selected.orgid : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Company Name" size="small" />
                                    )}
                                />
                            </Grid>

                            {/* <Grid item xs={1.8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="From Date"
                    value={info.ForPrdFrom}
                    views={["day", "month", "year"]}
                    onChange={(v) =>
                      handleChanges(
                        "ForPrdFrom",
                        moment(v).format("DD-MM-YYYY")
                      )
                    }
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </LocalizationProvider>
               </Grid>
                <Grid item xs={1.8}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="To Date"
                    value={info.ForPrdTo}
                    views={["day", "month", "year"]}
                    onChange={(newValue) =>
                      handleChanges(
                        "ForPrdTo",
                        moment(newValue).format("YYYY-MM-DD")
                      )
                    }
                    renderInput={(params) => (
                      <TextField fullWidth size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
               </Grid> */}


                            <Grid item xs={1.8}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={getReport}
                                    fullWidth
                                    disabled={isLoading || !info.orgid}
                                    sx={{ height: 40 }}
                                >
                                    {isLoading ? "Loading..." : "Submit"}
                                </Button>
                            </Grid>

                            {showTable && (
                                <Grid item xs={1.8}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleOpenAssignAP}
                                        fullWidth
                                        sx={{ height: 40 }}
                                    >
                                        Assign AP
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                        {showTable && (
                            <Grid container spacing={2} alignItems="center" mt={2}>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("StrategyName")}
                                        value={filters.StrategyName}
                                        onChange={(e, v) =>
                                            handleFilterChange("StrategyName", v || "")
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Strategy Name"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("LOB")}
                                        value={filters.LOB}
                                        onChange={(e, v) => handleFilterChange("LOB", v || "")}
                                        renderInput={(params) => (
                                            <TextField {...params} label="LOB" size="small" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("Function")}
                                        value={filters.Function}
                                        onChange={(e, v) => handleFilterChange("Function", v || "")}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Function" size="small" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("ActivityName")}
                                        value={filters.ActivityName}
                                        onChange={(e, v) =>
                                            handleFilterChange("ActivityName", v || "")
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Activity Name"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("ActivityCode")}
                                        value={filters.ActivityCode}
                                        onChange={(e, v) =>
                                            handleFilterChange("ActivityCode", v || "")
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Activity Code"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.8}>
                                    <Autocomplete
                                        fullWidth
                                        options={safeOptions("ActivityId")}
                                        value={filters.ActivityId}
                                        onChange={(e, v) =>
                                            handleFilterChange("ActivityId", v || "")
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Activity ID"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </AccordionDetails>
                </Accordion>

                {/* ── Toolbar: Add Row, Pagination, CSV ── */}
                {CSV_ARRAY.length > 0 && (
                    <Box
                        align="right"
                        sx={{
                            mt: 2,
                            mb: 1,
                            px: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 2,
                        }}
                    >
                        {/* Left: Add Row */}
                        <Box display="flex" gap={1}>
                            <Button
                                onClick={handleAddMainRow}
                                size="small"
                                startIcon={<AddIcon sx={{ fontSize: 16 }} />}
                                sx={{
                                    background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
                                    color: "#fff",
                                    fontWeight: 600,
                                    fontSize: "0.78rem",
                                    letterSpacing: "0.5px",
                                    px: 2,
                                    py: 0.7,
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 8px rgba(26,115,232,0.35)",
                                    textTransform: "none",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                        background: "linear-gradient(135deg, #1557b0 0%, #0a3880 100%)",
                                        boxShadow: "0 4px 14px rgba(26,115,232,0.5)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                Add Row
                            </Button>
                        </Box>

                        {/* Right: Pagination + CSV Download */}
                        <Box display="flex" alignItems="center" gap={1}>
                            <Pagination
                                count={Math.ceil(filteredRows.length / rowsPerPage)}
                                page={page + 1}
                                onChange={(event, newPage) => handleChangePage(event, newPage - 1)}
                                variant="outlined"
                                shape="rounded"
                                showFirstButton
                                showLastButton
                            />
                            &nbsp;
                            <CSVLink
                                filename={`ActivityPlan_${moment().format("DD-MM-YYYY_HH-mm-ss")}.csv`}
                                data={CSV_ARRAY}
                            >
                                <Button variant="contained" color="success" size="small">
                                    <GetApp />
                                </Button>
                            </CSVLink>
                        </Box>
                    </Box>
                )}

                {/* Main Table */}
                {showTable && (
                    <>
                        {/* ── Inline Edit Panel (shown when exactly 1 row is selected) ── */}
                        {editingMainRow && (
                            <Paper
                                elevation={2}
                                sx={{
                                    px: 2,
                                    py: 1.5,
                                    mt: 1,
                                    mb: 1,
                                    border: "1.5px solid #1976d2",
                                    borderRadius: 2,
                                    backgroundColor: "#f5f9ff",
                                    position: "relative",
                                }}
                            >
                                {/* Header row */}
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                                    <Typography variant="body2" fontWeight={700} color="primary">

                                    </Typography>
                                    <Box display="flex" gap={1.5} alignItems="center">
                                        <Button
                                            variant="outlined"
                                            color="info"
                                            size="small"
                                            sx={{ fontSize: "0.72rem", py: 0.5, px: 2, textTransform: "none", borderRadius: 1.5 }}
                                            onClick={() => {
                                                setClipboardRow({ ...editingMainRow });
                                                setSnackbar({ open: true, message: "Row copied!" });
                                            }}
                                        >
                                            Copy
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            size="small"
                                            disabled={!clipboardRow}
                                            sx={{ fontSize: "0.72rem", py: 0.5, px: 2, textTransform: "none", borderRadius: 1.5 }}
                                            onClick={() => {
                                                if (clipboardRow) {
                                                    setEditingMainRow({ ...clipboardRow });
                                                    setSnackbar({ open: true, message: "Row pasted!" });
                                                }
                                            }}
                                        >
                                            Paste
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{ fontSize: "0.72rem", py: 0.5, px: 2, textTransform: "none", borderRadius: 1.5 }}
                                            onClick={handleSaveEditMainRow}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            variant="text"
                                            size="small"
                                            sx={{ fontSize: "0.72rem", py: 0.5, px: 1.5, textTransform: "none", color: "#666", minWidth: 0 }}
                                            onClick={() => {
                                                setEditingMainRow(null);
                                                setEditingMainRowIndex(null);
                                                setCheckedMainRows([]);
                                            }}
                                        >
                                            Close
                                        </Button>
                                    </Box>
                                </Box>

                                {/* Fields in a compact single row */}
                                <Grid container rowSpacing={1.5} columnSpacing={2}>
                                    {ACTIVITY_COLUMNS.map((col) => {
                                        if (col.key === "ForPrdFrom") {
                                            return (
                                                <Grid item xs={6} sm={4} md={2.4} key={col.key}>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DatePicker
                                                            label={col.label}
                                                            value={editingMainRow[col.key] ? moment(editingMainRow[col.key], "YYYY-MM-DD") : null}
                                                            onChange={(v) => {
                                                                setEditingMainRow((prev) => ({
                                                                    ...(prev || {}),
                                                                    [col.key]: v ? v.format("YYYY-MM-DD") : "",
                                                                }));
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    size="small"
                                                                    inputProps={{ ...params.inputProps, style: { fontSize: "0.85rem" } }}
                                                                    InputLabelProps={{ style: { fontSize: "0.85rem", fontWeight: 600, color: "#000000ff" } }}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                            );
                                        }

                                        if (col.key === "ActivityId") {
                                            return (
                                                <Grid item xs={6} sm={4} md={2.4} key={col.key}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label={col.label}
                                                        value={editingMainRow[col.key] || ""}
                                                        onChange={(e) => {
                                                            setEditingMainRow((prev) => ({
                                                                ...(prev || {}),
                                                                [col.key]: e.target.value,
                                                            }));
                                                        }}
                                                        inputProps={{ style: { fontSize: "0.85rem" } }}
                                                        InputLabelProps={{
                                                            style: {
                                                                fontSize: "0.85rem",
                                                                fontWeight: 600,
                                                                color: "#000000ff"
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            );
                                        }



                                        return (
                                            <Grid item xs={6} sm={4} md={2.4} key={col.key}>
                                                <Autocomplete
                                                    freeSolo
                                                    forcePopupIcon={true}
                                                    options={col.key === "LOB" ? LOB : safeOptions(col.key)}
                                                    value={editingMainRow[col.key] || ""}
                                                    onChange={(e, v) => {
                                                        setEditingMainRow((prev) => ({
                                                            ...(prev || {}),
                                                            [col.key]: v || "",
                                                        }));
                                                    }}
                                                    onInputChange={(e, v) => {
                                                        if (col.key !== "LOB") {
                                                            setEditingMainRow((prev) => ({
                                                                ...(prev || {}),
                                                                [col.key]: v || "",
                                                            }));
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                            label={col.label}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                readOnly: col.key === "LOB",
                                                                style: {
                                                                    fontSize: "0.85rem",
                                                                    fontSize: "0.85rem",
                                                                    cursor: col.key === "LOB" ? "pointer" : "text"
                                                                }
                                                            }}
                                                            InputLabelProps={{
                                                                style: {
                                                                    fontSize: "0.85rem",
                                                                    fontWeight: 600,
                                                                    color: "#000000ff"
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                    componentsProps={{
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: 'flip',
                                                                    enabled: false,
                                                                },
                                                                {
                                                                    name: 'preventOverflow',
                                                                    enabled: false,
                                                                },
                                                            ],
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Paper>
                        )}

                        {/* Table */}
                        <TableContainer component={Paper} sx={{ mt: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Checkbox
                                                checked={checkedMainRows.length === CSV_ARRAY.length}
                                                onClick={handleSelectAllMain}
                                                inputProps={{
                                                    "aria-label": "Select all",
                                                }}
                                            />
                                        </TableCell>
                                        {ACTIVITY_COLUMNS.map((col) => (
                                            <TableCell key={col.key} sx={{ fontWeight: "bold" }}>{col.label}</TableCell>
                                        ))}
                                        <TableCell
                                            sx={{
                                                fontWeight: "bold",
                                                position: "sticky",
                                                right: 0,
                                                backgroundColor: "#fff",
                                                zIndex: 2,
                                                boxShadow: "-2px 0px 4px -2px rgba(0,0,0,0.2)"
                                            }}
                                        >
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(filteredRows.length > 0 &&
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            : filteredRows
                                        ).map(({ row, originalIndex }) => (
                                            <TableRow
                                                key={originalIndex}
                                                selected={checkedMainRows.includes(originalIndex)}
                                                sx={{
                                                    backgroundColor: checkedMainRows.includes(originalIndex)
                                                        ? "#e3f2fd"
                                                        : "inherit",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <TableCell>
                                                    <Checkbox
                                                        checked={checkedMainRows.includes(originalIndex)}
                                                        onClick={() => handleCopyChange(originalIndex)}
                                                        icon={<CheckBoxOutlineBlankIcon />}
                                                        checkedIcon={<CheckBoxIcon />}
                                                    />
                                                </TableCell>
                                                {ACTIVITY_COLUMNS.map((col) => (
                                                    <TableCell key={col.key}>{row[col.key]}</TableCell>
                                                ))}
                                                <TableCell
                                                    sx={{
                                                        position: "sticky",
                                                        right: 0,
                                                        backgroundColor: checkedMainRows.includes(originalIndex) ? "#e3f2fd" : "#fff",
                                                        zIndex: 1,
                                                        boxShadow: "-2px 0px 4px -2px rgba(0,0,0,0.2)"
                                                    }}
                                                >
                                                    <DeleteIcon
                                                        sx={{ cursor: "pointer", color: "error.main" }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setDeleteConfirmDialog({ open: true, index: originalIndex });
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))) || (
                                            <TableRow>
                                                <TableCell colSpan={ACTIVITY_COLUMNS.length + 1}>
                                                    <Alert severity="error">No Data Found!</Alert>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}

                {/* ── Snackbar Toast ── */}
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={5000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    message={snackbar.message}
                    action={
                        snackbar.isUndo ? (
                            <Button color="secondary" size="small" onClick={handleUndo}>
                                UNDO
                            </Button>
                        ) : null
                    }
                />

                {/* ── Delete Confirm Dialog ── */}
                <Dialog open={deleteConfirmDialog.open} onClose={() => setDeleteConfirmDialog({ open: false, index: null })}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <Typography>Are you sure you want to delete this row?</Typography>
                    </DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 2 }}>
                        <Button onClick={() => setDeleteConfirmDialog({ open: false, index: null })}>Cancel</Button>
                        <Button variant="contained" color="error" onClick={confirmDeleteRow}>Confirm</Button>
                    </Box>
                </Dialog>

                {/* ASSIGN AP POPUP */}
                <Dialog
                    open={openAssignAP}
                    onClose={handleCloseAssignAP}
                    fullWidth
                    maxWidth={false}
                    PaperProps={{ sx: { width: "98vw", height: "95vh" } }}
                >
                    <DialogTitle sx={{ fontWeight: "bold" }}>
                        Assign AP
                        <CloseIcon
                            onClick={handleCloseAssignAP}
                            style={{ float: "right", cursor: "pointer", color: "#444" }}
                        />
                    </DialogTitle>

                    {/* LOB Dropdown at Top */}
                    <Box mt={1} mb={2} sx={{ marginLeft: 2 }}>
                        <Grid container spacing={2} alignItems="center" mt={2}>
                            <Grid item xs={4}>
                                <Autocomplete
                                    options={Companies.map((c) => c.orgname)}
                                    value={
                                        Companies.find((c) => c.orgid === info.orgid)?.orgname || ""
                                    }
                                    onChange={(e, v) => {
                                        const selected = Companies.find((c) => c.orgname === v);
                                        handleChanges("orgid", selected ? selected.orgid : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Company Name" size="small" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Autocomplete
                                    forcePopupIcon={true}
                                    options={[...LOB, "Verifier"] || []}
                                    value={selectedLOB || ""}
                                    onChange={(e, value) => {
                                        const newValue = value || "";
                                        setSelectedLOB(newValue);
                                        setAssignAPRows(prev => prev.map(row => ({ ...row, LOB: newValue, lob: newValue })));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="LOB"
                                            variant="outlined"
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps,
                                                readOnly: true,
                                                style: { cursor: "pointer" }
                                            }}
                                        />
                                    )}
                                    componentsProps={{
                                        popper: {
                                            modifiers: [
                                                { name: 'flip', enabled: false },
                                                { name: 'preventOverflow', enabled: false },
                                            ],
                                        },
                                    }}
                                />
                            </Grid>
                            {info.orgid === "" && LOB.length === 0 && (
                                <Grid item xs={4}>
                                    <Alert severity="warning">
                                        Select a company to load the LOB options.
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>
                    </Box>

                    <DialogContent
                        dividers
                        sx={{
                            padding: 2,
                            overflowX: "auto",
                            overflowY: "auto",
                            borderTop: "1px solid #d3d3d3",
                            minWidth: "1200px",
                            height: "78vh",
                        }}
                    >
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {assignAPColumns.map((col) => (
                                        <TableCell key={col.key} sx={{ position: "relative", fontWeight: "bold", backgroundColor: "#fff", zIndex: 1 }}>
                                            {col.label}
                                        </TableCell>
                                    ))}
                                    <TableCell sx={{ fontWeight: "bold", backgroundColor: "#fff", zIndex: 1 }}>
                                        Action
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {assignAPRows.map((row, idx) => (
                                    <TableRow key={idx}>

                                        {assignAPColumns.map((col) => {
                                            let cellWidth = "200px";
                                            if (col.key === "ForPrdFrom" || col.key === "ForPrdTo") {
                                                cellWidth = "130px";
                                            }
                                            if (col.key === "ActivityId") {
                                                cellWidth = "125px";
                                            }

                                            if (col.key === "ForPrdFrom" || col.key === "ForPrdTo") {
                                                return (
                                                    <TableCell key={col.key} sx={{ minWidth: cellWidth }}>
                                                        <DatePicker
                                                            value={row[col.key] ? moment(row[col.key]) : null}
                                                            onChange={(v) =>
                                                                handleFieldEdit(
                                                                    idx,
                                                                    col.key,
                                                                    v ? moment(v).format("YYYY-MM-DD") : "",
                                                                    "assign"
                                                                )
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField {...params} size="small" />
                                                            )}
                                                        />
                                                    </TableCell>
                                                );
                                            }

                                            if (col.key === "ActivityId") {
                                                return (
                                                    <TableCell key={col.key} sx={{ minWidth: cellWidth }}>
                                                        <TextField
                                                            size="small"
                                                            variant="outlined"
                                                            value={row[col.key] ?? ""}
                                                            onChange={(e) =>
                                                                handleFieldEdit(idx, col.key, e.target.value, "assign")
                                                            }
                                                        />
                                                    </TableCell>
                                                );
                                            }

                                            const options = safeOptions(col.key);
                                            return (
                                                <TableCell key={col.key} sx={{ minWidth: cellWidth }}>
                                                    <Autocomplete
                                                        key={`${row.ActivityCode}-${col.key}-${idx}`}
                                                        options={options}
                                                        value={row[col.key] ?? ""}
                                                        freeSolo
                                                        onInputChange={(e, v) =>
                                                            handleFieldEdit(idx, col.key, v ?? "", "assign")
                                                        }
                                                        onChange={(e, v) =>
                                                            handleFieldEdit(idx, col.key, v ?? "", "assign")
                                                        }
                                                        isOptionEqualToValue={(option, value) =>
                                                            option === value
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        componentsProps={{
                                                            popper: {
                                                                modifiers: [
                                                                    {
                                                                        name: 'flip',
                                                                        enabled: false,
                                                                    },
                                                                    {
                                                                        name: 'preventOverflow',
                                                                        enabled: false,
                                                                    },
                                                                ],
                                                            },
                                                        }}
                                                        disableClearable={false}
                                                    />
                                                </TableCell>
                                            );
                                        })}

                                        <TableCell sx={{ position: "sticky", right: 0, backgroundColor: "#fff", zIndex: 1, boxShadow: "-2px 0 5px -2px rgba(0,0,0,0.1)" }}>
                                            <Box
                                                sx={{ display: "flex", alignItems: "center", gap: 2 }}
                                            >
                                                <AddIcon
                                                    onClick={() => handleAddAssignAPRow(idx)}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontSize: "26px",
                                                        color: "#1976d2",
                                                    }}
                                                />
                                                <DeleteIcon
                                                    onClick={() => handleDeleteAssignAPRow(idx)}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontSize: "26px",
                                                        color: "red",
                                                    }}
                                                />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </DialogContent>

                    {/* Buttons moved to bottom center */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                            py: 2,
                            pr: 4,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSaveAssignAP}
                            disabled={isLoading}
                        >
                            Save
                        </Button>

                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "red",
                                "&:hover": { backgroundColor: "#b30000" },
                            }}
                            onClick={handleCloseAssignAP}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>

                <Snackbar
                    open={!!alert?.message}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    autoHideDuration={7000}
                >
                    <Alert severity="error" variant="filled">
                        {alert?.message}&nbsp;
                        <Button
                            variant="text"
                            sx={{ color: "white" }}
                            onClick={handleUndoDelete}
                        >
                            UNDO
                        </Button>
                    </Alert>
                </Snackbar>
            </div>
        </LocalizationProvider>
    );
}